// extracted by mini-css-extract-plugin
export var button = "Event-module--button--128c3";
export var buttonGroup = "Event-module--buttonGroup--b6e35";
export var card = "Event-module--card--f2634";
export var date = "Event-module--date--61243";
export var description = "Event-module--description--04987";
export var dot = "Event-module--dot--a5477";
export var infoColumn = "Event-module--infoColumn--25b46";
export var isPast = "Event-module--isPast--b2761";
export var isUpcoming = "Event-module--isUpcoming--5c889";
export var logo = "Event-module--logo--50326";
export var logoColumn = "Event-module--logoColumn--5c8d8";
export var logoWrapper = "Event-module--logoWrapper--ef949";
export var meta = "Event-module--meta--474ff";
export var playIcon = "Event-module--playIcon--c067d";
export var root = "Event-module--root--1e19d";
export var thumbnail = "Event-module--thumbnail--0e93b";
export var thumbnailColumn = "Event-module--thumbnailColumn--ff5ac";
export var thumbnailWrapper = "Event-module--thumbnailWrapper--45fbf";
export var title = "Event-module--title--61ea4";